export default __webpack_public_path__ + "static/img1-487a4c4e029087b415946f3f21a96d5e.jpg";